import Swal from 'sweetalert2';
import { QrverifyCodeApi } from '../../Apis/user/ApiConfig';
import {
    MFASETTINGS_QR_VERIFY_SUCCESS,
    MFASETTINGS_QR_VERIFY_ERROR,
    MFASETTINGS_QR_VERIFY_REQUEST,
} from '../../Types/user/Types';
import { UserProfileActionHandler } from './SettingsUserProfile';

export const MfasettingsQrVerifySuccess = (res) => {
    return {
        type: MFASETTINGS_QR_VERIFY_SUCCESS,
        payload: res,
    };
};
export const MfasettingsQrVerifyError = (error) => {
    return {
        type: MFASETTINGS_QR_VERIFY_ERROR,
        error: error,
    };
};
export const MfasettingsQrVerifyRequest = (res) => {
    return {
        type: MFASETTINGS_QR_VERIFY_REQUEST,
        payload: res,
    };
};
export const QrCodeVerifyActionHandler = (data, callback) => {
    return (dispatch) => {
        dispatch(MfasettingsQrVerifyRequest());
        try {
            QrverifyCodeApi(data)
                .then((res) => {
                    const errorMessage = res?.response?.data?.data;
                    const status = res?.response?.status;
                    if (res) {
                        if (res && res.data && res.status === 200) {
                            dispatch(MfasettingsQrVerifySuccess(res.data));
                            dispatch(UserProfileActionHandler());
                            callback(null, res.data);
                            Swal.fire({
                                position: 'centre',
                                icon: 'success',
                                title: 'Verification successfully',
                                showConfirmButton: false,
                                timer: 1000,
                            });
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: errorMessage,
                                confirmButtonColor: 'rgb(231,52,70)',
                            });
                            dispatch(MfasettingsQrVerifyError(errorMessage));
                            callback(status);
                        }
                    } else {
                        dispatch(MfasettingsQrVerifyError(errorMessage));
                    }
                })
                .catch((err) => {
                    dispatch(
                        MfasettingsQrVerifyError('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(MfasettingsQrVerifyError(err));
        }
    };
};
